import {RelayEnvironmentProvider, relayEnvironmentWithMissingFieldHandlerForNode} from '@github-ui/relay-environment'
import {useState} from 'react'

export function CopilotRelayEnvironmentProvider({children}: React.PropsWithChildren) {
  const [environment] = useState(() => relayEnvironmentWithMissingFieldHandlerForNode())

  return <RelayEnvironmentProvider environment={environment}>{children}</RelayEnvironmentProvider>
}
